import { VStack, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { Appetizer } from '@novaheal/types';

type Props = {
  appetizerData: Appetizer[];
};

export const AppetizerSection = ({ appetizerData }: Props): ReactElement => {
  const appetizerDataText = appetizerData.map((appetizer) => appetizer.value).join(', ');

  return (
    <VStack align="left" gap="30px" mb="50px" px={{ base: 'l', md: '40px' }}>
      <Text textStyle="body.m.italic" color="text.accent">
        {appetizerDataText}
      </Text>
    </VStack>
  );
};
